import { Card} from "reactstrap";
import CommonHeaderWithDropDown from "./common/CommonHeaderWithDropDown";
import { TotalUsers, WeeklyMonDropdown } from "../../../../Constant";
import TotalUserBody from "./TotalUserBody";

const TotalUserWidget = () => {
  return (
    <Card>
      <CommonHeaderWithDropDown
        headerClassName="pb-0"
        dropDownIcon={true}
        heading={TotalUsers}
        dropDownList={WeeklyMonDropdown}
        caret={false}
        dropDownClass="dropdown icon-dropdown"
      />
      <TotalUserBody />
    </Card>
  );
};

export default TotalUserWidget;
